

// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';
import { walletKycStatuses } from '../statuses';

export default class WalletUsersKycPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'wallet-users-kyc';
        this.Server = this.props.context.getState().server.walletUsersKyc;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['uuid', 'sumsubId', 'passport'];

        const defaultHead = [
            {
                id: 'uuid',
                label: 'uuid',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'userId',
                label: 'user',
                alignRight: false,
                cell: 'Select',
                displayGrid: true,
                from: 'walletUsers',
                object: 'user',
                show: 'email'
            },
            {
                id: 'sumsubId',
                label: 'sumsubId',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'passport',
                label: 'passport',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'dataJson',
                label: 'dataJson',
                alignRight: false,
                cell: 'Json',
                displayGrid: false,
                disableEditor: true,
                displayDialogDetails: true,
                details: 'Json'
            },
            {
                id: 'status',
                label: 'status',
                alignRight: false,
                cell: 'Items',
                displayGrid: true,
                items: Object.values(walletKycStatuses)
            },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'modifiedBy',
                label: 'modifiedBy',
                alignRight: false,
                cell: 'Select',
                object: 'modifiedBy',
                show: 'firstName+lastName',
                displayGrid: true,
                disableEditor: true,
                customSort: 'modifiedBy.firstName'
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}

